import { Button } from '@/components/ui/button';

export default function NotFoundPage() {
    return (
        <div
            dir="rtl"
            className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-green-50 to-emerald-100 p-6 text-center"
        >
            <div className="space-y-6 max-w-md">
                <div className="space-y-3">
                    <h1 className="text-8xl font-bold text-green-600">۴۰۴</h1>
                    <h2 className="text-2xl font-semibold text-gray-800">
                        صفحه مورد نظر یافت نشد
                    </h2>
                    <p className="text-green-700">
                        صفحه‌ای که به دنبال آن هستید وجود ندارد یا ممکن است منتقل شده باشد.
                    </p>
                </div>

                <div className="flex flex-col sm:flex-row gap-3 justify-center">
                    <Button asChild className="bg-green-600 hover:bg-green-700 text-white">
                        <a href="/">بازگشت به صفحه اصلی</a>
                    </Button>
                    <Button
                        variant="outline"
                        onClick={() => window.history.back()}
                        className="border-green-400 text-green-700 hover:bg-green-50"
                    >
                        بازگشت به صفحه قبل
                    </Button>
                </div>

                <div className="pt-4 text-sm text-green-600">
                    © {new Date().getFullYear()}لایسنس اپ
                </div>
            </div>
        </div>
    );
}
